import { render, staticRenderFns } from "./UiDialog.vue?vue&type=template&id=a4ec0768&scoped=true"
import script from "./UiDialog.vue?vue&type=script&lang=js"
export * from "./UiDialog.vue?vue&type=script&lang=js"
import style0 from "./UiDialog.vue?vue&type=style&index=0&id=a4ec0768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ec0768",
  null
  
)

export default component.exports